import type { TUploadedFile } from '@onesource/schemas';
import { useDeleteMediaFileMutation } from '@onesource/services';
import { enqueueSnackbar } from 'notistack';
import { useCallback } from 'react';

import { useConfirmService } from '../dialogs';

export function useMediaDelete() {
  const { setConfirm } = useConfirmService();
  const { mutateAsync, isPending } = useDeleteMediaFileMutation();

  const deleteFile = useCallback(
    (file: TUploadedFile) => {
      setConfirm({
        title: 'Delete media file',
        open: true,
        message: `Delete "${file.filename}"? It will be permanently removed from the library. Make sure it is not in use anywhere else before deleting.`,
        onConfirm: async () => {
          try {
            await mutateAsync(file.key); // file.key is the media file ID
            enqueueSnackbar('Media file deleted', { variant: 'success' });
          } catch (error) {
            const message = error instanceof Error ? error.message : 'Failed to delete media file';
            enqueueSnackbar(message, { variant: 'error' });
          }
        },
      });
    },
    [setConfirm, mutateAsync],
  );

  return { deleteFile, isPending };
}
